'use client'

import { CircleNotchIcon } from '@phosphor-icons/react'
import { cn } from '@/lib/tailwind'

interface FormSubmitSectionProps {
  isLoading: boolean
  hasContent: boolean
}

/**
 * Submit button for the capture form.
 * Always visible — disabled when empty, spinner when loading.
 */
export function FormSubmitSection({
  isLoading,
  hasContent,
}: FormSubmitSectionProps) {
  return (
    <button
      type="submit"
      disabled={isLoading || !hasContent}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
        'bg-brand-accent hover:bg-brand-accent/90 text-white',
        'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
        'disabled:pointer-events-none disabled:opacity-40',
      )}
    >
      {isLoading ? (
        <CircleNotchIcon className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <span>Create</span>
      )}
    </button>
  )
}
